import { NgModule, ModuleWithProviders } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FileUploadModule } from 'ng2-file-upload';
import { AuthGuard,AuthService, RoleGuard,MessageBrokerService,PendingChangesGuard} from './core/index';
import { NotificationsService } from './helper-components/index';

import { ClearanceItemAssetManagerComponent } from '../clearance-item/asset-management/clearance-item-asset-manager.component';
import { ClearanceItemAssetBaseComponent } from '../clearance-item/asset-management/clearance-item-asset-base.component';
import { ClearanceItemImageComponent } from '../clearance-item/asset-management/clearance-item-image.component';
import { ClearanceItemDocumentComponent } from '../clearance-item/asset-management/clearance-item-document.component';
import { SharedModule } from "./shared.module";
import { CommonModule } from '@angular/common';
import { AssetDirective } from "../clearance-item/asset-management/clearance-item-asset-directive";
import { ModalComponent } from "./helper-components/modal/_directives/modal.component";
import { HttpModule } from "@angular/http";
import { ModalService } from "./helper-components/modal/_services/modal.service";
import { ClickOutsideDirective } from './clickoutside.directive';
import { ClearanceItemService } from '../clearance-item';
import { MaterializeModule } from 'angular2-materialize';
import { CarouselComponent } from '../clearance-item/carousel.component';

@NgModule({
  imports: [
    HttpModule,
    CommonModule,
    FileUploadModule,
    SharedModule,
    FormsModule,
    ReactiveFormsModule,
    MaterializeModule
  ],
  declarations: [
    ClearanceItemAssetManagerComponent,
    ClearanceItemAssetBaseComponent,
    ClearanceItemImageComponent,
    ClearanceItemDocumentComponent,
    AssetDirective,
    ModalComponent,
    ClickOutsideDirective,
    CarouselComponent
  ],
  exports:[
    ClearanceItemAssetManagerComponent,    
    ClearanceItemAssetBaseComponent,
    ClearanceItemImageComponent,
    ClearanceItemDocumentComponent,
    FileUploadModule,
    HttpModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    CarouselComponent
  ],
  providers:[
         ModalService
  ],
  entryComponents: [
    ClearanceItemAssetBaseComponent, 
    ClearanceItemImageComponent, 
    ClearanceItemDocumentComponent
  ]
  
})
export class AssetManagerModule {

  static forRoot(): ModuleWithProviders {
    return {
      ngModule: AssetManagerModule,
      providers: [AuthGuard,AuthService, RoleGuard,MessageBrokerService,PendingChangesGuard,NotificationsService, ModalService, ClearanceItemService]
    };
  }
}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/shared/asset-manager.module.ts